import { lazy } from "react";

const Benefit = lazy(() => import("../pages/benefit/Benefit"));
const BenefitHistory = lazy(() => import("../pages/benefit/history/BenefitHistory"));

export const benefitRoutes = [
  { path: "/benefit", element: <Benefit /> },
  { path: "/benefit/history", element: <BenefitHistory /> },
];
